export const description = [
  "This condition usually resolves on its own. Over-the-counter products and at-home remedies can help you manage your symptoms.",
  "This condition usually resolves on its own. Over-the-counter products and at-home remedies can help you manage your symptoms.",
  "This condition is unlikely to escalate, but it should be evaluated for treatment within a few days. Options include telemedicine, a walk-in clinic, or calling your primary care doctor.",
  "This condition is not urgent, but it requires attention. Your primary care doctor can evaluate, diagnose, and treat this condition, or they can help you coordinate further care if needed.",
  "This condition should be looked at in the next day or two. Your primary care doctor can evaluate, diagnose, and treat this condition, or they can help you coordinate further care if needed.",
  "This condition is not life threatening, but it should be treated today. Options include visiting your primary care doctor, a walk-in clinic, or an urgent care center. It is not necessary to visit an ER.",
  "This condition requires immediate medical care.",
  "This condition is an emergency that could be life threatening. Consider calling 911."
]

export const care = [
  "Usually resolves on its own",
  "",
  "Sometime in the next 3 days",
  "See within 2 weeks",
  "See within 1-2 days",
  "Today, or as soon as possible",
  "",
  ""
]

// TODO: update copy when Adam generates it.
export const title = [
  "Why waiting and watching is the right choice",
  "Why self-treatment is the right choice",
  "Why a phone call or in-person visit is the right choice",
  "Why primary care is the right choice",
  "Why primary care is the right choice",
  "Why an in-person visit is the right choice",
  "Why the ER is the right choice",
  "",
]

export const newTitles = [
  "Why wait and watch?",
  "Why self-treat?",
  "Why a phone call or in-person visit?",
  "Why primary care?",
  "Why primary care?",
  "Why an in-person visit?",
  "Why the ER?",
  "",
]


// WEBPACK FOOTER //
// ./assets/completion/triageCopy.js